<template>
  <div class="lookExpert">
    <navbar :showShadow="false" :scrollChange="false" :tabId="4"></navbar>
    <div class="ExpertTop dis_f_c_c">
      <div style="width: 1200px" class="dis_f_sb_c">
        <div class="left dis_f_l_c">
          <img
            class="fit ExpertTopImg"
            src="@/images/expert/expert-icon.png"
            alt=""
          />
          <div class="ExpertTopTitle">为您精选靠谱的物流专家</div>
        </div>
        <div class="right dis_f_l_c">
          <el-input
            v-model="form.keyword"
            placeholder="输入关键词查找"
            @keyup.enter.native="search"
            placeholder-style="font-size: 14px;color: #989899;"
          ></el-input>
          <i class="el-icon-search dis_f_r_c search hand" @click="search()"></i>
        </div>
      </div>
    </div>
    <div class="banxin">
      <div class="header">
        <nav-options
          :list="portList"
          :isOpen="false"
          :isAll="false"
          @listMethods="portMethods"
          name="口岸"
          class=""
        ></nav-options>
        <navs-open
          :list="statusLists"
          :isOpen="false"
          :isAll="false"
          @listMethods="statusMethods"
          name="分类"
          v-if="statusType"
        ></navs-open>
      </div>
      <div class="" v-if="!pageLoading">
        <!-- 专家推荐 -->
        <div
          class="empty dis_f_c_c"
          v-loading="expertLoading"
          v-if="page.total == 0"
        >
          <div class="dis_f_co_c_c">
            <div class="emptyImg">
              <img class="fit" src="@/images/common/empty.png" alt="" />
            </div>
            <div class="emptyTitle">
              暂无查询信息，可更换信息查询或者稍后查询~
            </div>
          </div>
        </div>
        <div class="expert-area" v-loading="expertLoading" v-else>
          <div class="expert-wrapper">
            <div class="list-panel">
              <div
                class="item"
                :class="{ 'no-margin': (index + 1) % 2 === 0 }"
                v-for="(item, index) in expertList"
                :key="index"
                @click="openDetail(item.id, item.freightCompanyId)"
              >
                <div class="item-wrapper">
                  <div class="left">
                    <div class="photo">
                      <img
                        class="photo-img fill"
                        :src="
                          item.headPic
                            ? item.headPic
                            : require('@/images/common/noAvatar.png')
                        "
                      />
                      <img
                        class="male"
                        src="@/images/common/male.png"
                        v-if="item.sex == 1"
                      />
                      <img
                        class="type male"
                        src="@/images/common/female.png"
                        v-if="item.sex == 2"
                      />
                    </div>
                  </div>
                  <div class="right">
                    <div class="name">
                      <div class="text">{{ item.name }}</div>
                      <!-- 推广标识 0取消 1置顶', -->
                      <div class="recommend" v-if="item.spread == 1">推荐</div>
                    </div>
                    <div class="company">{{ item.companyName }}</div>
                    <div class="year">从业经验:{{ item.jobTime }}</div>
                    <div class="desc">擅长:{{ item.expertIn }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="tableFenye dis_f_c_c" v-if="page.total > 0">
          <el-pagination
            background
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNo"
            @current-change="inputPageNo"
            layout="prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </div>
      <div v-else class="page-loading" v-loading="pageLoading"></div>
    </div>
    <login
      @close="showLogin = false"
      v-if="showLogin"
      @success="() => {}"
      @fail="() => {}"
    ></login>
  </div>
</template>
<script>
import {
  querydicdatalistwizard,
  getexpertslist,
  getuserqueryexpertpermission,
} from "@/api/lookExpert/lookExpert";
import navOptions from "@/components/nav-options.vue";
import navsOpen from "@/components/navs-open.vue";
import { isInputEmpty } from "@/utils/typeCheck";
import { mapState } from "vuex";
export default {
  name: "lookExpert",
  data() {
    return {
      //口岸
      portList: [
        { id: 1, name: "上海" },
        { id: 2, name: "青岛" },
        { id: 3, name: "深圳" },
        { id: 4, name: "宁波" },
        { id: 5, name: "广州" },
        { id: 6, name: "天津" },
        { id: 7, name: "大连" },
        { id: 8, name: "厦门" },
      ],
      //口岸
      statusLists: [],
      statusType: false,
      // options
      page: {
        pageNo: 1, //页数
        pageSize: 12, //分页数
        total: 0, //总数
      },
      form: {
        keyword: "", //关键字
        areaStr: "", //口岸
        type: "1", //分类
        typeStr: [], //分类数据
      },
      expertList: [], //专家类别
      expertLoading: true, //专家loading
      showLogin: false, //登录弹窗
      pageLoading: true,
    };
  },
  components: {
    navOptions,
    navsOpen,
  },
  watch: {},
  computed: {
    ...mapState("user", {
      userId: (state) => state.userId,
    }),
  },
  async created() {
    this.pageLoading = true
    // 专家分类
    await this.expertStatus();
    // 列表
      this.page.pageNo = 1;
    await this.lookList();
    this.pageLoading = false
  },
  methods: {
    // 口岸方法
    async portMethods(e) {
      console.log(e);
      let list = e.array;
      let port = [];
      list.forEach((arr) => {
        port.push(arr.id);
      });
      this.form.areaStr = port.join(",");
      // 列表
      this.page.pageNo = 1;
      await this.lookList();
    },
    // 分类方法
    async statusMethods(e) {
      let list = e.array;
      let status = [];
      list.forEach((arr) => {
        status.push(arr.id);
      });
      this.form.typeStr = status;
      // 列表
      this.page.pageNo = 1;
      await this.lookList();
    },
    // 专家分类
    async expertStatus() {
      // ==========接口调用==========
      let res;
      let params = { typeId: 305 };
      try {
        res = await querydicdatalistwizard(params);
        // console.log('分类',res)
        let list = res;
        let statusLists = [];
        list.forEach((arr) => {
          statusLists.push({ id: arr.id, name: arr.name });
        });
        this.$nextTick(() => {
          this.statusType = true;
          this.statusLists = statusLists;
        });
      } catch (e) {
        console.error(e);
      }
    },
    // 列表
    async lookList() {
      // ==========接口调用==========
      let res;
      let params = {
        ...this.form,
      };
      params.pageNo = this.page.pageNo;
      params.pageSize = this.page.pageSize;
      this.expertLoading = true; //加载loading
      try {
        res = await getexpertslist(params);
        this.page.total = res.total; //总条数
        this.expertList = res.rows || [];
        // console.log(this.tableData)
        this.expertLoading = false;
      } catch (e) {
        this.expertLoading = false;
        console.error(e);
      }
    },
    // 详情
    async openDetail(id, freightCompanyId) {
      if (this.userId) {
        try {
          let params={ id: id }
          let res = await getuserqueryexpertpermission(params);
          if(res.code==0){
            this.$message({ message: res.message, type: "error" });
          }else{
            let routeData = this.$router.resolve({
              path: "/expertDetail",
              query: { id: id, freightCompanyId: freightCompanyId },
            });
            window.open(routeData.href, "_blank");
          }
        } catch (e) {
          console.error(e);
        }
        // this.$router.push({
        //   path: "/expertDetail",
        //   query: { id: id, freightCompanyId: freightCompanyId },
        // });
      } else {
        this.showLogin = true;
      }
    },

    switchExpertFilter(index) {
      this.expertFilterIndex = index;
    },
    // ==============================分页==============================
    // 当前页码改变
    inputPageNo: function (pageNo) {
      console.log("page chagne:", pageNo);
      this.page.pageNo = pageNo;
      this.lookList();
    },
    // 搜搜
    search() {
      if (isInputEmpty(this.form.keyword)) {
        this.$message({ type: "warning", message: "关键字搜索不能为空" });
        return;
      }
      this.page.pageNo = 1;
      this.lookList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
@mixin themeTransition {
  // transition: background-color 0.3s, border-color 0.3s, color 0.3s, opacity 0.3s;
  transition: all 0.2s;
}
@mixin panelTransition {
  transition: all 0.3s;
}
.lookExpert {
  $searchHeight: 84px;
  // padding-top: 192px;
  padding-top: $navbarHeight + $searchHeight + 24px;
  background: #f5f9ff;
  // min-height: calc(100vh - #{$footerHeight});
  min-height: 100vh;
  /deep/ .el-loading-mask {
    z-index: 10;
  }
  .ExpertTop {
    position: fixed;
    top: 74px;
    left: 0;
    width: 100%;
    height: $searchHeight;
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px #ebeef3;
    z-index: 99;
    .left {
      .ExpertTopImg {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      .ExpertTopTitle {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #373842;
      }
    }
    .right {
      width: 454px;
      height: 44px;
      background: #ebeef3;
      border-radius: 4px;
      padding: 12px 20px 12px 30px;
      /deep/.el-input {
        width: 100%;
        border: none !important;
        background: #ebeef3 !important;
        font-size: 14px!important;
        .el-input__inner {
          padding: 0 !important;
        }
        input {
          border: none !important;
          background: #ebeef3 !important;
        }
      }
      .search {
        font-size: 18px;
        color: #989899;
        margin-left: 10px;
        flex: none;
      }
    }
  }
  .banxin {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 32px;
    .header {
      padding: 14px 20px 10px;
      background: #ffffff;
      border-radius: 12px;
      margin-bottom: 32px;
    }
    .expert-area {
      width: 100%;
      position: relative;
      background: #f5f9ff;
      .expert-wrapper {
        width: 1200px;
        margin: auto;
        padding-bottom: 14px;
        .filter-panel {
          display: flex;
          align-items: center;
          margin-bottom: 28px;
          position: relative;
          .title {
            margin-right: 30px;
            display: flex;
            align-items: center;
            .icon {
              display: block;
              width: 32px;
              height: auto;
              margin-right: 16px;
            }
            .text {
              font-size: 22px;
              font-weight: bold;
              color: #272a31;
            }
          }
          .filter-list {
            display: flex;
            align-items: center;
            .tab {
              height: 34px;
              border-radius: 4px;
              padding: 0 12px;
              font-size: 14px;
              font-weight: 500;
              color: #45484e;
              margin-right: 24px;
              cursor: pointer;
              display: flex;
              align-items: center;
              @include themeTransition();
              &:hover {
                color: var(--themeColor);
              }
              &.tab--active {
                background: var(--themeBg);
                font-size: 14px;
                font-weight: 500;
                color: var(--themeColor);
              }
            }
          }
          .more-btn {
            position: absolute;
            right: 0px;
            font-size: 14px;
            font-weight: 500;
            color: #373842;
            cursor: pointer;
            &:hover {
              color: var(--themeColor);
            }
          }
        }
        .list-panel {
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .item {
            cursor: pointer;
            width: 584px;
            height: 234px;
            flex: 0 0 auto;
            margin-right: calc((100% - 584px * 2));
            margin-bottom: 30px;
            position: relative;
            top: 0px;
            @include panelTransition();
            border-radius: 12px;
            overflow: hidden;
            background: #ffffff;
            .item-wrapper {
              width: 100%;
              display: flex;
              align-items: flex-start;
              .left {
                flex: 0 0 auto;
                padding: 24px 20px 0 24px;
                .photo {
                  width: 94px;
                  height: 94px;
                  position: relative;
                  overflow: hidden;
                  .photo-img {
                    border-radius: 50%;
                    // display: block;
                    height: 100%;
                    width: 100%;
                    // height: auto;
                    object-fit: cover;
                  }
                  .male {
                    z-index: 10;
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    display: block;
                    right: 4px;
                    bottom: 4px;
                  }
                }
              }
              .right {
                padding: 30px 36px 0 0;
                overflow: hidden;
                .name {
                  display: flex;
                  align-items: center;
                  margin-bottom: 8px;
                  .text {
                    font-size: 18px;
                    font-weight: bold;
                    color: #262f38;
                    margin-right: 10px;
                  }
                  .recommend {
                    padding: 0 6px;
                    height: 18px;
                    background: linear-gradient(54deg, #fb7f44, #fe5654);
                    border-radius: 14px 0px 14px 0px;
                    font-size: 12px;
                    font-weight: bold;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
                .company {
                  margin-bottom: 10px;
                  font-size: 14px;
                  font-weight: 500;
                  color: #727781;
                }
                .year {
                  font-size: 14px;
                  font-weight: 500;
                  color: #45484e;
                  line-height: 23px;
                }
                .desc {
                  font-size: 14px;
                  font-weight: 500;
                  color: #45484e;
                  line-height: 23px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 4; //向显示多少行就给多大值
                  -webkit-box-orient: vertical;
                }
              }
            }
            &.no-margin {
              margin-right: 0;
            }
          }
          .item:hover {
            top: -6px;
            box-shadow: 0px 3px 12px 0px #e7eaef;
            .item-wrapper {
            }
          }
        }
      }
    }
    .empty {
      width: 100%;
      height: calc(100vh - 362px);
      .emptyImg {
        width: 254px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .emptyTitle {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #676b76;
      }
    }
    .tableFenye {
      padding-bottom: 52px;
    }
    .page-loading {
      width: 100%;
      height: 340px;
      background: #f5f9ff;
      /deep/ .el-loading-mask {
        background: #f5f9ff;
        z-index: 10;
      }
    }
  }
}
</style>